var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.455 6.4c0-.442-.367-.8-.819-.8h-3.272c-.452 0-.818.358-.818.8v.8H7.909v-.8c0-1.325 1.1-2.4 2.455-2.4h3.272c1.356 0 2.455 1.075 2.455 2.4v.8h2.49c1.325 0 2.4 1.075 2.4 2.4v7.9c0 1.325-1.075 2.4-2.4 2.4H5.42c-1.326 0-2.4-1.075-2.4-2.4V9.6c0-1.325 1.074-2.4 2.4-2.4h9.034v-.8zM12 16.2c-2.22 0-4.677-.828-7.379-2.466V17.5c0 .442.357.8.8.8h13.16c.44 0 .8-.358.8-.8l-.001-3.766C16.678 15.372 14.22 16.2 12 16.2zm6.58-7.4H5.42c-.442 0-.8.358-.8.8v2.359l.17.112C7.524 13.831 9.93 14.7 12 14.7c2.114 0 4.577-.905 7.38-2.74V9.6c0-.442-.358-.8-.8-.8zM12 11.45c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z",
    transform: "translate(-136 -330) translate(40 330) translate(96)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.30e886d3.svg";
export { ForwardRef as ReactComponent };